const classify = (cls: string): string => `.${cls}`;
export default classify;
